import React, { FunctionComponent, useCallback } from 'react';

import { forTemplate } from '@trello/i18n';
import {
  SectionMessage,
  SectionMessageAction,
} from '@trello/nachos/section-message-experimental';

const format = forTemplate('description');

export const EditorLoadErrorMessage: FunctionComponent = () => {
  const reloadPage = useCallback(() => {
    location.reload();
  }, []);

  const reloadAction = (
    <SectionMessageAction onClick={reloadPage}>
      {format('refresh-page')}
    </SectionMessageAction>
  );

  return (
    <div className="desc-editor-chunk-load-error">
      <SectionMessage appearance="error" actions={[reloadAction]}>
        {format('there-was-an-error-loading')}
      </SectionMessage>
    </div>
  );
};
